import Layout from "app/components/layout/Layout";
import AuthGuard from "app/guard/authGuard";
import {infoRouter} from "./infoRouter";
import {mngRouter} from "./mngRouter";
import {dbRouter} from "./dbRouter";
import {mpRouter} from "app/routers/mpRouter";
import {cpRouter} from "./cpRouter";
import {rpRouter} from "./rpRouter";
import {cbRouter} from "./cbRouter";
import {otRouter} from "./otRouter";
import {reportRouter} from "./reportRouter";
import {pcRouter} from "./pcRouter";
import { adminRouter } from "app/routers/adminRouter";
import {brokerRouter} from "./brokerRouter";


export const indexRouter: any = {
  path: "/",
  element: (
      <AuthGuard>
        <Layout/>
      </AuthGuard>
  ),
  children: [
    // user or common routers
    ...dbRouter,
    ...mngRouter,
    ...mpRouter,
    ...cpRouter,
    ...rpRouter,
    ...cbRouter,
    ...otRouter,
    ...reportRouter,
    ...pcRouter,
    ...infoRouter,

    // admin router
    ...adminRouter,
    ...brokerRouter
  ],
};